// extracted by mini-css-extract-plugin
export var container = "_qc-0";
export var table = "_qc-2";
export var tableWrapper = "_qc-1";